import gql from 'graphql-tag';
import { CompanyLogoSchema } from '../../definitions/schemas';
import Interface from '../Interface';
import { companyLogoFields } from './CompanyLogoField';

interface GetCompanyLogosInput {
  search: string;
}

interface GetCompanyLogosData {
  getCompanyLogos: CompanyLogoSchema[];
}

export default class CompanyLogoInterface extends Interface {
  public async getCompanyLogos(
    variables: GetCompanyLogosInput,
    fields = companyLogoFields
  ) {
    const data = await this.query<GetCompanyLogosData>(
      () =>
        this.apolloService.executeQuery<GetCompanyLogosData>({
          query: gql`
            query companyLogos($search: String!) {
              getCompanyLogos(search: $search) {
                ${fields}
              }
            }
          `,
          variables,
        }),
      'Error listing Company Logos'
    );
    return data.getCompanyLogos!;
  }
}
